<template>
  <router-view />
  <el-dialog
    v-model="loginVisible"
    v-if="loginVisible"
    title="登录"
    width="560"
    :before-close="handleClose"
    class="login"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
    >
      <el-form-item prop="username">
        <el-input
          v-model="form.username"
          @keyup.enter.native="login"
          placeholder="请输入统一社会信用代码"
        />
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="form.password"
          type="password"
          @keyup.enter.native="login"
          placeholder="请输入密码"
          show-password
        />
      </el-form-item>
      <div class="function">
        <div>没有账号，去<span
            class="btn"
            @click="register"
          >注册</span></div>
        <div
          @click="forgot"
          class="btn"
        >忘记密码？</div>
      </div>
      <el-form-item>
        <el-button
          size="large"
          type="primary"
          @click.native.prevent="login"
        >登录</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      loginVisible: false,
      form: {},
      rules: {
        username: [
          {
            required: true,
            message: '统一社会信用代码不能为空',
            trigger: 'blur',
          },
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    handleClose() {
      this.loginVisible = false;
      this.$store.state.state = false;
    },
    login() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.$store
            .dispatch('Login', this.form)
            .then(() => {
              location.reload()
            })
        }
      });
    },
    register() {
      this.handleClose();
      this.$router.push('/register');
    },
    forgot() {
      this.handleClose();
      this.$router.push('/forgot');
    },
  },
  watch: {
    '$store.state.state': function (val) {
      if (val) {
        this.loginVisible = true;
      }
    },
  },
};
</script>

<style lang="scss">
* {
  margin: 0;
}
body {
  background-color: #f4f4f4;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>

<style lang="scss">
.login .el-dialog__body {
  padding: 20px 50px;
  .el-form-item__content {
    .el-button {
      width: 100%;
    }
  }
  .function {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;
    > div {
      font-size: 16px;
      color: #333;
      font-family: "PingFangSC-Regular";
      font-weight: 400;
      span {
        color: #0b6cf9;
      }
    }
    .btn {
      cursor: pointer;
    }
  }
}
</style>
